import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BlogArticle from "../components/blog/BlogArticle";
import BlogHome from "../components/blog/BlogHome";
import PageMeta from "../components/seo/PageMeta";
import { getBlogPostById, BLOG_POSTS } from "../data/blog";
import {
  buildArticleJsonLd,
  buildBreadcrumbJsonLd,
  buildWebPageJsonLd,
  parseDisplayDate,
} from "../lib/seo";
import "../styles/blog.css";
import "../styles/stories.css";

export default function BlogPage() {
  const { postId } = useParams();
  const navigate = useNavigate();
  const post = postId ? getBlogPostById(postId) : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [postId]);

  useEffect(() => {
    if (postId && !post) {
      navigate("/blog", { replace: true });
    }
  }, [postId, post, navigate]);

  const backToHome = () => {
    navigate("/blog");
  };

  if (post) {
    const publishedTime = parseDisplayDate(post.date);
    const path = `/blog/${post.id}`;

    return (
      <>
        <PageMeta
          title={post.title}
          description={post.blurb}
          path={path}
          image={post.img}
          type="article"
          section={post.cat}
          keywords={post.kw.split(" ")}
          publishedTime={publishedTime}
          modifiedTime={publishedTime}
          jsonLd={[
            buildWebPageJsonLd({
              title: post.title,
              description: post.blurb,
              path,
              image: post.img,
            }),
            buildArticleJsonLd({
              title: post.title,
              description: post.blurb,
              path,
              image: post.img,
              datePublished: publishedTime,
              section: post.cat,
              keywords: post.kw.split(" "),
            }),
            buildBreadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Blog", path: "/blog" },
              { name: post.title, path },
            ]),
          ]}
        />
        <BlogArticle post={post} onBack={backToHome} />
      </>
    );
  }

  return (
    <>
      <PageMeta
        title="The Blog"
        description="Thoughts on product, technology, photography, and the road — a notebook for ideas in progress from CJ Jayamaha."
        path="/blog"
        image={BLOG_POSTS[0]?.img || "cjmeister-com-_DSC5184.jpg"}
        keywords={["blog", "field notes", "product management", "photography", "technology"]}
        jsonLd={buildWebPageJsonLd({
          title: "The Blog",
          description:
            "Essays and field notes on product, technology, photography, and travel by CJ Jayamaha.",
          path: "/blog",
          image: BLOG_POSTS[0]?.img || "cjmeister-com-_DSC5184.jpg",
        })}
      />
      <BlogHome />
    </>
  );
}
